import Layout from './components/landing/Layout';
import { PartyContext, usePartyContext } from './utils/party/party';

export interface IStore {
	loggedIn: boolean;
	username: string;
}

function App() {
	// https://www.youtube.com/watch?v=FGCsuwIORb0&list=PL4cUxeGkcC9ij8CfkAY2RAGb-tmkNwQHG&index=36
	// const initState = {
	// 	loggedIn: false,
	// 	username: "",
	// };

	// const reducer: Reducer<IStore, any> = (state: IStore = initState, action) => {

	// }

	// createStore(reducer);

	const context = usePartyContext();

	return <PartyContext.Provider value={context}>
		<Layout />
	</PartyContext.Provider>;
}

export default App;
